module.exports = __webpack_public_path__ + "img/head.b4a8b8d7.jpg";